import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export const REQ_STATUS = {
  pending: { label: "Pending", chip: "bg-amber-50 text-amber-700 border-amber-200" },
  approved: { label: "Approved", chip: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  rejected: { label: "Rejected", chip: "bg-red-50 text-red-700 border-red-200" },
  closed: { label: "Closed", chip: "bg-slate-100 text-slate-600 border-slate-200" },
};

export const REIMB_CATEGORIES = ["Travel", "Meals", "Software", "Hardware", "Internet / Phone", "Training", "Other"];

let currencyCache = null;
export function useCurrency() {
  const [cur, setCur] = useState(currencyCache ?? "");
  useEffect(() => {
    if (currencyCache !== null) return;
    api.get("/config").then(({ data }) => { currencyCache = data.currency || ""; setCur(currencyCache); }).catch(() => {});
  }, []);
  return cur;
}

export function fmtMoney(v, cur = "") {
  return `${cur}${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtDay(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}

export function fmtRange(a, b) {
  return a === b ? fmtDay(a) : `${fmtDay(a)} – ${fmtDay(b)}`;
}

export async function openReceipt(r) {
  const win = window.open("", "_blank");
  try {
    const { data } = await api.get(`/reimbursements/${r.id}/receipt`, { responseType: "blob" });
    const url = URL.createObjectURL(data);
    if (win) win.location.href = url; else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch {
    if (win) win.close();
    toast.error("Could not open receipt");
  }
}
